import { render, staticRenderFns } from "./enterprise_label.vue?vue&type=template&id=1f0220af&scoped=true&"
import script from "./enterprise_label.vue?vue&type=script&lang=js&"
export * from "./enterprise_label.vue?vue&type=script&lang=js&"
import style0 from "./enterprise_label.vue?vue&type=style&index=0&id=1f0220af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0220af",
  null
  
)

export default component.exports